<ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()">{{ alert.message }}</ngb-alert>
<div class="row">
  <div class="col-sm-12 col-md-8 col-lg-12 m-auto">
    <div
      class="row d-lg-flex justify-content-center mx-0"
    >

      <ng-container *appFeatureFlag="'isIdentialertAvailable'">
        <div class="product-plan-card-wrapper mb-4 identialert-mobilview">
          <app-product-plan-card
            [productPlanCard]="mainCardTypes.PremiumSubscription"
            [disabled]="!identiAlertAvailable"
            (onError)="onCardError()">
          </app-product-plan-card>
        </div>
      </ng-container>

      <!--identibase+-->
      <ng-container *appFeatureFlag="'isIdentiPlusAvailable'">
        <div
          class="col-lg-3 col-xxl-2 text-center mb-4 identibaseplus-price-card-wrapper"
        >
          <app-price-card
            [viewOnly]="viewOnly"
            [showShortDescription]="showShortDescription"
            [showInfoLine]="showInfoLine"
            [showFeatures]="appPriceCardFeatureText ? true : showFeatures"
            [buttonLabel]="buttonLabel"
            [hidePrices]="hidePrices"
            [disabledBuyNow]="!identibasePlusAvailable"
            [disabled]="disabled"
            [showPeachBanner]="showPeachBanner"
            [planId]="pricingPlans.identibasePlus"
            [hideIcon]="hideIcons"
            [hasBuyNow]="hasBuyNow"
            (onSelect)="select($event)"
            (onNavigateToProductPage)="
              onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS)
            "
            [highlighted]="false"
            imageUri="/assets/images/pricingTable/identibasePlus.svg"
            planTitle="{{ plan1Name }}"
            [planLongSubtitle]="appPriceCardFeatureText ? 'Secure & up to date details' : 'For less than ' + plan1DailyPrice + ' per day, activate your pet’s Digital ID with:'"
            [hidePlusFromSubtitle]="true"
            [features]="appPriceCardFeatureText ? appPriceCardFeatureText : getFeaturesFor(planFeatureService.plan1Name)"
            yearlyPrice="{{ plan1YearlyPrice }}"
            [descriptionList]="showDescriptionList ? appPriceCardFeatureText : null"
            [description]="appPriceCardFeatureText ? '' 
            :  'Get your missing pet home more quickly by activating your pet’s Digital ID. And, with identibase+, keep the Digital ID up to date withunlimited changes to your details.'"
          ></app-price-card>
        </div>
      </ng-container>
      
      <ng-container *appFeatureFlag="'isIdentialertAvailable'">
        <div class="product-plan-card-wrapper col-lg mb-4 identialert-desktopview">
          <app-product-plan-card
            [productPlanCard]="mainCardTypes.PremiumSubscription"
            [user]="user"
            [imagePosition]="'center 36%'"
            [disabled]="!identiAlertAvailable"
            (onError)="onCardError()"
          >
          </app-product-plan-card>
        </div>
      </ng-container>

      <ng-container *appFeatureFlag="'isIdentiSmartTagPlanAvailable'">
        <div class="product-plan-card-wrapper col-lg mb-4 order-first order-lg-last">
          <app-product-plan-card
            [productPlanCard]="mainCardTypes.SmartTag"
            [user]="user"
            [imagePosition]="'center 20%'"
            [disabled]="!smartTagSubAvailable"
            (onError)="onCardError()"
          >
          </app-product-plan-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>
